
function ImprintEn() {

    return (
        <div className="content">
            <article>
                <h1>Imprint</h1>
                <p><strong>Information according to § 5 TMG:</strong></p>
                <p>Anne Hensel<br />
                Marienthaler Str. 47<br />
                20535 Hamburg</p>

                <p><strong>Contact:</strong></p>
                <p>Email: info@apartment5-wismar.de</p>

                <p><strong>Responsible for the content according to § 55 Abs. 2 RStV:</strong></p>
                <p>Anne Hensel<br />
                Marienthaler Str. 47<br />
                20535 Hamburg</p>

                <p><strong>Disclaimer:</strong></p>
                <p>The contents of this page were created with the greatest care. However, we cannot accept 
                    any liability for the accuracy, completeness and topicality of the content.
                </p>
                <p>We accept no liability for links to external websites, as we have no influence on their 
                    content. Responsibility for the content of the linked pages always lies with the 
                    provider or operator of the pages. The permanent monitoring of external content
                    for legal violations without concrete evidence is not reasonable for us. Should we 
                    become aware of legal violations, we will remove the corresponding external 
                    links immediately.
                </p>
                <p>We are an independent third party not endorsed by or affiliated with Airbnb, Inc. or 
                    any of its subsidiaries or affiliates. Bookings are made exclusively via Airbnb, we do 
                    not offer our own booking systems via the website.
                </p>
                <p>All photos used on this website were created with the kind permission of the authors. Any 
                    further use of the images is not permitted without the express consent of the author.
                </p>
                <p><strong>Integration of third-party services</strong></p>
                <p>Within our online offer, we use service offers from third-party providers on the basis of the 
                    legitimate interest within the meaning of Art. 6 para. 1 lit. f. GDPR in order to integrate 
                    their services, such as fonts.<br />
                    We integrate the fonts (‘Google Fonts’) of the provider Google LLC, 1600 Amphitheatre Parkway, 
                    Mountain View, CA 94043, USA. Privacy policy: {/*
                    */}<a href="https://www.google.com/policies/privacy/">https://www.google.com/policies/privacy/</a>, 
                    Opt-Out: <a href="https://adssettings.google.com/authenticated">https://adssettings.google.com/authenticated</a>.
                    </p><br />
                <h3>Privacy Policy</h3>
                <p><strong>Responsible party</strong></p>
                <p>Anne Hensel<br />
                    Marienthaler Str. 47<br />
                    20535 Hamburg</p>
                <p><strong>Website hosting</strong></p>
                <p>This website is hosted by the following provider:<br />
                    STRATO GmbH<br />
                    Otto-Ostrowski-Straße 7<br />
                    10249 Berlin<br />
                </p>
                <p>When you visit this website, the hosting provider automatically collects the following data in
                    so-called server log files:<br />
                    Domain, anonymised client IP, request line, timestamp, status code, size of the response body, 
                    referrer sent by the client, user agent sent by the client, remote user.<br />
                    The data is stored for security reasons, e.g. to recognise and ward off attacks on the website. 
                    The log files are deleted after a maximum of seven days. This is based on the legal basis of 
                    legitimate interests, Art. 6 para. 1 lit. f GDPR.</p>
                <p><strong>Redirect to Airbnb</strong></p>
                <p>On this website you will find links to the Airbnb platform. When you click on these links, data 
                    (such as your IP address) is transmitted to Airbnb. Data processing on Airbnb is governed by their 
                    privacy policy, which you can view here: {/*
                    */}<a href="https://www.airbnb.de/help/article/3175/">https://www.airbnb.de/help/article/3175/</a>. 
                </p>
                <p><strong>Rights of those affected</strong></p>
                <p>You have the right to: Information about the processing of your data, rectification or erasure of 
                    your data, restriction of processing, objection to the processing of your data, data portability.
                    </p>
                <p><strong>Right of appeal</strong></p>
                <p>If you believe that the processing of your data violates the GDPR, you can lodge a complaint with 
                    the competent data protection authority.</p>
            </article>
        </div>
    );
}

export default ImprintEn;